export default () => ({
	openTimesDropdownOpen: false,
});
